/// <reference path="../common-types.d.ts" />
/// <reference path="./data-models.d.ts" />
import axios, { AxiosResponse } from 'axios'

export const getTestError = async (): Promise<AxiosResponse> => {
    return await axios.get(`${appSettings.ApiUrl}/api/ErrorTest`, { withCredentials: true })
}
